<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><a id="pg7">CONTENTS</a></p><a id="pg7">
</a><p class="toc"><a id="pg7"></a><a href="#/acknowledgement#Ack">Acknowledgements</a></p>
<p class="toc"><a href="#/prologue#Pro">Prologue. The Mail Rider</a></p>
<p class="toc1"><a href="#/chapter01#C1">1. “A Vast Pastoral Domain”</a></p>
<p class="toc"><span href="#/chapter02#C2" title="Link target outside of Sample">2. “Leftenant, They Killed Them All”</span></p>
<p class="toc"><span href="#/chapter03#C3" title="Link target outside of Sample">3. Murieta’s Head</span></p>
<p class="toc"><span href="#/chapter04#C4" title="Link target outside of Sample">4. The Vigilance Committee</span></p>
<p class="toc"><span href="#/chapter05#C5" title="Link target outside of Sample">5. “Parties to This Jury Unknown”</span></p>
<p class="toc"><span href="#/chapter06#C6" title="Link target outside of Sample">6. Robbers and Cops</span></p>
<p class="toc"><span href="#/chapter07#C7" title="Link target outside of Sample">7. The Murder of Silver Dove</span></p>
<p class="toc"><span href="#/chapter08#C8" title="Link target outside of Sample">8. Desperados</span></p>
<p class="toc"><span href="#/chapter09#C9" title="Link target outside of Sample">9. Roaring Twenties</span></p>
<p class="toc1"><span href="#/bibliography#Bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthors#Abo" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0c51677c